<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "@/components/common/questionnaires/question/helpers/questionLoadHelpers";
import { general } from "@/components/common/questionnaires/question/options/general";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import InputRadio from "@/components/common/questionnaires/question/inputs/InputRadio";

export default {
  name: 'TrustsChangedYN',
  mixins: [general, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    saveLocation: {
      type: String,
      default: 'amendment_data'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'Are you currently involved in a trust, either as a beneficiary or a creator, that has experienced changes recently?',
        subTitle: 'Trusts are complex legal structures that interact closely with your Will and overall estate plan. If a trust you created has been wound up, or if you have started receiving money from a new family trust, it changes your financial footprint. Reviewing these changes ensures your Will and any trusts work together seamlessly, rather than creating legal conflicts or unexpected tax bills.',
        tip: null,
      },
      db: {
        saveLocation: 'amendment_data',
        saveField: 'trustsChangedYN',
        formPath: 'trustsChangedYN',
        jsonSaveField: 'trustsChangedYN',
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
